import Highcharts, { PlotColumnOptions } from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';
import { Center, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from 'global.module.css';
import { SymptomSeverities } from 'models/generic';

interface BarChartProps {
  chartOptions: PlotColumnOptions;
}

export const BarChart = ({ chartOptions }: BarChartProps) => {
  const { t } = useTranslation();

  return (
    <Stack gap={'xs'}>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      <Center>
        <Group>
          {Object.values(SymptomSeverities)
            .reverse()
            .map((severity) => (
              <Text className={classes.cursorDefault} size={'xs'} key={severity}>
                {`${severity} = ${t(`symptom_severity_${severity}`)}`}
              </Text>
            ))}
        </Group>
      </Center>
    </Stack>
  );
};
